<template>
<!-- Team Area Start -->
<section class="team-area home-3-primary-dark-bg" id="team">
    <div class="container">
        <div class="row">
            <!-- All Team Members Wrapper Start-->
            <div class="all-team-members-wrapper">

                <!-- Single Team Member Box Start-->
                <div class="col-12 col-md-6">
                    <div class="section-title-area team-title-area">
                        <div class="team-title-collection">
                          <SmallHeading :smallTitle="smallTitle" />
                          <SectionHeading2 :title="title" :titleInner="titleInner" />  
                        </div>
                        
                        <SectionSubHeading :subTitle="subTitle" /> 
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-3">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/1.jpg')" img-alt="Team" fluid></b-img>
                                        
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-3">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/2.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->


                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-6">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/3.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-3">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/4.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-3">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/5.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-3">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/6.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-3">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/7.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

                <!-- Single Team Member Box Start-->
                <div class="col-6 col-md-6">
                    <div class="team-member-box position-relative">
                        <b-img :src="require('../../assets/img/home-3-img/team-img/8.jpg')" img-alt="Team" fluid></b-img>
                        <div class="team-content position-absolute">
                            <h4>Todd Phillips</h4>
                            <h6>Product Owner</h6>
                            <ul class="team-social">
                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Single Team Member Box End-->

            </div>
            <!-- All Team Members Wrapper End-->
        </div>
    </div>
</section>
<!-- Team Area End -->
</template>

<script>
import SectionHeading2 from '@/components/default/SectionHeading2'
import SmallHeading from '@/components/home3/SmallHeading'
import SectionSubHeading from '@/components/default/SectionSubHeading'

export default {
  name: 'Team',

  components: {
    SectionHeading2,
    SmallHeading,
    SectionSubHeading
  },

  data() {
    return {
      smallTitle: 'Team',
      title: 'Development Team',
      titleInner: 'Meet the',
      subTitle: 'Goals are great, we all want gains and the positives that come along with them',
      };
  },

}
</script>
